import { AdminAPI, AdminCommonAPI } from "../../helper/API/API.base";
import { APIHeaderCors, getFormDataHeaders, getHeaders } from "../../helper/API/API.header";
import { ErrorToast, SuccessToast } from "../../helper/Toast";
import { toastMessage } from "../../helper/config/toastMessage.config";
import {
  CREATE_ACCESSORY_SUCCESS,
  DELETE_ACCESSORY_SUCCESS,
  LIST_ALL_ACCESSORIES_REQUEST,
  LIST_ALL_ACCESSORIES_SUCCESS,
  LIST_ALL_ACCESSORIES_FAILURE,
  UPDATE_ACCESSORY_SUCCESS,
} from "../constants/accessory";

export const listAllAccessories = () => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: LIST_ALL_ACCESSORIES_REQUEST });

      // API
      const response = await AdminCommonAPI.get("/accessory", APIHeaderCors);

      const accessoriesList = [];
      response?.data?.map((x) => {
        accessoriesList.push({
          id: x._id,
          image: x.image,
          name: x.name,
          description: x.description,
          price: x.price,
          colors: x.colors,
          is_active: x.is_active,
        });
      });

      dispatch({
        type: LIST_ALL_ACCESSORIES_SUCCESS,
        payload: accessoriesList,
      });

      resolve(response);
    } catch (error) {
      dispatch({
        type: LIST_ALL_ACCESSORIES_FAILURE,
        payload: error?.message,
      });

      // if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      // else
      if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
  });
};

export const updateAccessory = (values, accessoryId) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getFormDataHeaders();

      // AXIOS BODY
      const body = values;

      // API
      const response = await AdminAPI.put(`/accessory/${accessoryId}`, body, {
        headers,
      });

      dispatch({
        type: UPDATE_ACCESSORY_SUCCESS,
        payload: response?.data,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Accessory updated successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {

      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};

export const deleteAccessory = (values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getHeaders();

      // AXIOS BODY
      const accessoryId = values.id;

      // API
      const response = await AdminAPI.delete(`/accessory/${accessoryId}`, {
        headers,
      });

      dispatch({
        type: DELETE_ACCESSORY_SUCCESS,
        payload: accessoryId,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Accessory deleted successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {

      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};

export const createAccessory = (values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getFormDataHeaders();

      // AXIOS BODY
      const body = values;

      // API
      const response = await AdminAPI.post(`/accessory`, body, { headers });

      dispatch({
        type: CREATE_ACCESSORY_SUCCESS,
        payload: response?.data,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Accessory added successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {

      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};
